module.exports = __webpack_public_path__ + "static/media/products.132e2902.svg";